import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { EquipmentType } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { NavLink } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";

const AddType = () => {
  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/equipment_types`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
        },
      },
    });
    reset();
  };

  const equipmentTypes = useAppStore((store) => store.equipmentTypes)!;
  const setEquipmentTypes = useAppStore((store) => store.setEquipmentTypes);

  const addEquipmentItem = (itemSaveResponse: { data: unknown }) => {
    const newEquipmentTypesData = itemSaveResponse.data as unknown as EquipmentType;
    setEquipmentTypes([...equipmentTypes, newEquipmentTypesData]);
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    addEquipmentItem(itemSaveResponse);
  }, [itemSaveResponse]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/equipment_types"} className="text-sm flex gap-2 items-center text-muted-foreground hover:text-primary"><TbArrowLeft />{t("equipment_types")}</NavLink>
            <span className="text-2xl font-semibold">{t('adding_equipment_type')}</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="px-6">
          <div className="flex flex-col w-full h-full gap-2">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={t("title_name")} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddType;
